import React, { useEffect } from 'react';
import { compose } from '../../utils/compose';
import { AuthUserContext, withAuthorization, withEmailVerification } from '../Session';
import DashboardNav from '../Navigation/DashboardNav';
import PasswordChangeForm from './index';
import './styles.css';

const PasswordChangePage = () => {
  // Load and apply dark mode on mount
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    if (savedDarkMode) {
      document.body.classList.add('dark-mode');
    }
  }, []);

  return (
    <AuthUserContext.Consumer>
      {authUser => (
        <div className="password-change-page">
          <DashboardNav authUser={authUser} />
          <div className="password-change-container">
            <div className="password-change-card">
              <div className="password-change-header">
                <svg className="password-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                </svg>
                <h1>Change Password</h1>
                <p>Update your account password</p>
              </div>
              <PasswordChangeForm />
            </div>
          </div>
        </div>
      )}
    </AuthUserContext.Consumer>
  );
};

const condition = authUser => !!authUser;

export default compose(
  withEmailVerification,
  withAuthorization(condition),
)(PasswordChangePage);

